import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

type ViewValue = { hours: string; minutes: string };

class TimePickerComponentCtrl implements ng.IController {
    private ngModelCtrl: angular.INgModelController;

    public keysOfViewValue: (keyof ViewValue)[];
    public viewValue: ViewValue;
    public maxViewValue: ViewValue;
    public currentSelection: keyof ViewValue;
    public viewValueSteps: { [P in keyof ViewValue]: string[] };

    constructor(
        private $scope: angular.IScope,
        private utilService: UtilService
    ) {
        this.maxViewValue = { hours: '23', minutes: '59' };
        this.viewValueSteps = {
            hours: this.initViewValueSteps('hours'),
            minutes: this.initViewValueSteps('minutes')
        };
        this.keysOfViewValue = ['hours', 'minutes'];
    }

    $onInit(): void {
        this.$scope.$watch(
            () => this.viewValue,
            (newViewValue: ViewValue) =>
                newViewValue &&
                this.ngModelCtrl.$setViewValue(angular.copy(newViewValue)),
            true
        );

        this.ngModelCtrl.$parsers.push((viewValue: ViewValue): Date => {
            try {
                const date = new Date();
                date.setHours(parseInt(viewValue.hours));
                date.setMinutes(parseInt(viewValue.minutes));
                return date;
            } catch (e) {
                return undefined;
            }
        });

        this.ngModelCtrl.$formatters.push((modelValue: Date): ViewValue => {
            if (!modelValue || isNaN(modelValue.getTime())) {
                this.viewValue = {
                    hours: moment().hours().toString(),
                    minutes: moment().minute().toString()
                };
            } else {
                this.viewValue = {
                    minutes: modelValue.getMinutes().toString(),
                    hours: modelValue.getHours().toString()
                };
            }

            return this.viewValue;
        });

        // this.viewValue = {hours: moment().hours().toString(), minutes: moment().minute().toString()};
    }

    private initViewValueSteps(key: keyof ViewValue): string[] {
        const steps: string[] = [];

        if (key === 'hours') {
            let i;
            for (i = 0; i <= parseInt(this.maxViewValue[key]); i++) {
                steps.push(i.toString());
            }
        } else {
            let i;
            for (i = 0; i < this.maxViewValue[key]; i += 5) {
                steps.push(i.toString());
            }
        }

        return steps;
    }

    public increase(key: string): string {
        return this.viewValue[key] === this.maxViewValue[key]
            ? this.viewValue[key]
            : (parseInt(this.viewValue[key]) + 1).toString();
    }

    public decrease(key: string): string {
        return this.viewValue[key] === '0'
            ? this.viewValue[key]
            : (parseInt(this.viewValue[key]) - 1).toString();
    }
}

angular.module('app').component('pkpTimePicker', {
    controller: TimePickerComponentCtrl,
    template: require('app/_directives/time-picker.component.html'),
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {}
});
